require('./jquery-init');

module.exports = window.$;
